/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListProjectsVisibility = typeof ListProjectsVisibility[keyof typeof ListProjectsVisibility] | null;


export const ListProjectsVisibility = {
  private: 'private',
  shared: 'shared',
} as const;
